import * as yup from "yup"

export const passwordSchema = yup.object({
    password: yup.string().min(5).required(),
    confirmPassword: yup.string().oneOf([yup.ref("password"), null,], "").required()
})